import { ExclamationCircleOutlined } from "@ant-design/icons";
import { AxiosError } from "axios";
import { Button, message, Space, Spin } from "antd";
import { useTranslation } from "react-i18next";

import { useMutation, useQuery } from "@tanstack/react-query";
import { getTransactionsForRefund, transactionsPayout } from "../api";
import styles from "./index.module.scss";

export const ReturnTransactionsBlock = () => {
  const { t } = useTranslation();
  const [messageApi, contextHolder] = message.useMessage();

  const { data, isLoading } = useQuery({
    queryKey: ["return-transactions"],
    queryFn: () => getTransactionsForRefund(),
    refetchOnWindowFocus: true,
    staleTime: 0,
  });

  const { mutate: getPayout, isPending } = useMutation({
    mutationFn: (id: string) => transactionsPayout(id),
    onSuccess(response) {
      if (response.success) {
        window.open(response.form_url, "_self");
      } else {
        messageApi.error(t("refund.get_link_error"));
      }
    },
    onError(error: AxiosError<{ message: string }>) {
      messageApi.error(
        error.response?.data?.message || t("refund.get_link_error"),
      );
    },
  });

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: 80,
        }}
      >
        <Spin />
      </div>
    );
  }

  if (!data?.data.length) {
    return null;
  }

  return (
    <>
      {contextHolder}
      <div className={styles.block}>
        <div className={styles.iconWrapper}>
          <ExclamationCircleOutlined />
        </div>
        <Space vertical size="middle">
          {t("refund.refund_available")}
          <div className={styles.text}>
            {t("refund.refund_text", { amount: data.data[0].amount })}
          </div>
          <Button
            type="primary"
            onClick={() => getPayout(data?.data[0].id)}
            loading={isPending}
            disabled={isPending}
          >
            {t("refund.refund_button", { amount: data.data[0].amount })}
          </Button>
        </Space>
      </div>
    </>
  );
};
